// eslint-disable-next-line import/no-cycle

export const CONTEXT = {
  HEADER: 'header',
  HOME: 'home',
  PRODUCT_PAGE: 'product_page',
  LISTING_PAGE: 'listing_page',
  PRODUCT_DETAIL_DIALOG: 'product_detail_dialog',
  PRODUCT_RATING_AND_REVIEWS: 'product_rating_and_reviews',
  PRODUCT_PAYMENT_METHODS_DIALOG: 'product_payment_methods_dialog',
  PRODUCT_FREIGHT_DIALOG: 'product_freight_dialog',
  PRODUCT_FREIGHT: 'product_freight',
  SECTION_BLOG: 'section_blog',
  VERIFY_PAGE: 'verify_page',
  LOGIN_PAGE: 'login_page',
  RECOVER_EMAIL_PAGE: 'recover_email_page',
  RECOVER_PASSWORD_PAGE: 'recover_password_page',
  MFA_PAGE: 'mfa_page',
  CONFIRM_EMAIL_PAGE: 'confirm_email_page',
  NEW_PASSWORD_PAGE: 'new_password_page',
  LOGOUT_PAGE: 'logout_page',
  REGISTER_PAGE: 'register_page',
  COMPLETE_REGISTER_PAGE: 'complete_register_page',
  GENERAL: 'general',
  PRODUCT_INFORMATION: 'product_information',
  PRODUCT_DESCRIPTION: 'product_description',
  PRODUCT_CHARACTERISTICS: 'product_characteristics',
  PRODUCT_DESCRIPTION_DIALOG: 'product_description_dialog',
  PRODUCT_CHARACTERISTICS_DIALOG: 'product_characteristics_dialog',
  PRODUCT_SHOWCASE: 'product_showcase',
  PRODUCT_REVIEW_SUMMARY: 'product_review_summary',
  PRODUCT_RATING: 'product_rating',
  CART_PAGE: 'cart_page',
  CART_EMPTY: 'cart_empty',
  CART_INTERN_VIEW: 'cart_intern_view',
  CART_MENU: 'cart_menu',
  CART_SHARE: 'cart_share',
  CART_IMPORT: 'cart_import',
  CART_SCHEDULE: 'cart_schedule',
  CART_SELLER_CODE: 'cart_seller_code',
  CART_PREORDER: 'cart_preorder',
  CART_BUDGET: 'cart_budget',
  CART_COUPON: 'cart_coupon',
  CART_ZIPCODE: 'cart_zipcode',
  CART_SUMMARY: 'cart_summary',
  CART_ITEM: 'cart_item',
  CART_SERVICE: 'cart_service',
  CART_WARRANTY: 'cart_warranty',
  DELIVERY_REVIEW: 'delivery_review',
  DELIVERY_LIST: 'delivery_list',
  DELIVERY_ADDRESS: 'delivery_address',
  DELIVERY_ZIPCODE: 'delivery_zipcode',
  DELIVERY_FORM: 'delivery_form',
  PAYMENT_METHODS: 'payment_methods',
  PAYMENT_REVIEW: 'payment_review',
  PAYMENT_SUMMARY: 'payment_summary',
  PAYMENT_NUBANK: 'payment_nubank',
  PAYMENT_CARD: 'payment_card',
  PAYMENT_CDC: 'payment_cdc',
  PAYMENT_COMPOSITE: 'payment_composite',
  PAYMENT_POS: 'payment_pos',
} as const;

export const ROLE = {
  LINK: 'link',
  CONTAINER: 'container',
  FORM: 'form',
  BUTTON: 'button',
  LIST: 'list',
  DIALOG: 'dialog',
  CARD: 'card',
  RATING: 'rating',
  SLIDER: 'slider',
  INPUT: 'input',
  TEXTBOX: 'textbox',
  TEXT: 'text',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  LISTBOX: 'listbox',
  SWITCH: 'switch',
  IMAGE: 'image',
  FLAG: 'flag',
} as const;

export const ELEMENT = {
  COMPONENT_RATING: 'component_rating',
  SECTION_BLOG: 'section_blog',
  SECTION_CONTACT_CARD: 'section_contact_card',
  SECTION_CONTACT_CARD_SKELETON: 'section_contact_card_skeleton',
  SECTION_CALCULATOR: 'section_calculator',
  SECTION_CALCULATOR_SKELETON: 'section_calculator_skeleton',
  SECTION_FAQ: 'section_faq',
  SECTION_FAQ_ITEM: 'section_faq_item',
  SECTION_FAQ_FOOTER: 'section_faq_footer',
  SECTION_FAQ_FOOTER_ITEM: 'section_faq_footer_item',
  SECTION_SEO_TEXT: 'section_seo_text',
  SEARCH_FILTER_TITLE: 'search_filter_title',
  SEARCH_FILTER_FIXED_MOBILE: 'search_filter_fixed_mobile',
  SEARCH_FILTER_VISUAL_FILTERS: 'search_filter_visual_filters',
  SEARCH_FILTER_FACETS: 'search_filter_facets',
  ORDER_BY: 'order_by',
  SECTION_VIDEO_PARTNERS: 'section_video_partners',
  SECTION_DEFAULT_AND_CONTACT_CARD: 'section_default_and_contact_card',
  SECTION_FEATURE_CARD: 'section_feature_card',
  SECTION_FEATURE_CARD_SKELETON: 'section_feature_card_skeleton',
  SECTION_INLINE_BANNER: 'section_inline_banner',
  SECTION_INLINE_BANNER_SKELETON: 'section_inline_banner_skeleton',
  SECTION_BANNER_DEFAULT: 'section_banner_default',
  SECTION_BANNER_DEFAULT_SKELETON: 'section_banner_default_skeleton',
  SECTION_VIDEO_BANNER: 'section_video_banner',
  SECTION_VIDEO_BANNER_SKELETON: 'section_video_banner_skeleton',
  SECTION_GALLERY_CARD_CHIP: 'section_gallery_card_chip',
  SECTION_GALLERY_CARD_CHIP_SKELETON: 'section_gallery_card_chip_skeleton',
  ACTION_BOX: 'action_box',
  PRODUCT_CARD: 'product_card',
  PRODUCT_CARD_IMAGE: 'product_card_image',
  PRODUCT_CARD_WISHLIST_BUTTON: 'product_card_wishlist_button',
  PRODUCT_CARD_NAME: 'product_card_name',
  PRODUCT_CARD_PRICE_FROM: 'product_card_price_from',
  PRODUCT_CARD_PRICE_TO: 'product_card_price_to',
  PRODUCT_CARD_FREIGHT_FLAG: 'product_card_freight_flag',
  PRODUCT_CARD_CAMPAIGN_FLAG: 'product_card_campaign_flag',
  PRODUCT_CARD_VARIANTS: 'product_card_variants',
  PRODUCT_PRICE: 'product_price',
  CONTACT_CARD: 'contact_card',
  DEFAULT_CARD: 'default_card',
  PRODUCT_FREIGHT: 'product_freight',
  QUESTION_SECTION: 'question_section',
  QUESTION_ASK: 'question_ask',
  QUESTION_ITEM: 'question_item',
  QUESTIONS_EMPTY: 'questions_empty',
  PRODUCT_SELLER_REPUTATION: 'seller_reputation',
  PRODUCT_ENSEMBLE: 'product_ensemble',
  PRODUCT_ENSEMBLE_SKELETON: 'product_ensemble_skeleton',
  PRODUCT_ENSEMBLE_DIALOG_CONTENT: 'product_ensemble_dialog_content',
  PRODUCT_ENSEMBLE_DIALOG_FOOTER: 'product_ensemble_dialog_footer',
  PRODUCT_RATING_AND_REVIEWS: 'product_rating_and_reviews',
  PRODUCT_COUNTDOWN: 'product_countdown',
  PRODUCT_COUPON: 'product_coupon',
  PRODUCT_CLOCK: 'product_clock',
  INFOLINE: 'infoline',
  EMPTY: 'empty',
  FILTERS: 'filters',
  REVIEWS: 'reviews',
  PRODUCT_PAYMENT_METHODS_DIALOG_FOOTER: 'product_payment_methods_dialog_footer',
  PRODUCT_PAYMENT_METHODS_DIALOG_CONTENT: 'product_payment_methods_dialog_content',
  FREIGHT_CALCULATED: 'freight_calculated',
  FREIGHT_UNAVAILABLE: 'freight_unavailable',
  DIALOG_CONTENT: 'dialog_content',
  CARD: 'card',
  HEADER: 'header',
  SKELETON: 'skeleton',
  LOGIN: 'login',
  LOGOUT: 'logout',
  PASSWORD: 'password',
  SOCIAL_LOGIN: 'social_login',
  REGISTER: 'register',
  GO_BACK: 'go_back',
  GO_HOME: 'go_home',
  RECOVER: 'recover',
  SUCCESS_FEEDBACK: 'success_feedback',
  ERROR_FEEDBACK: 'error_feedback',
  PINCODE: 'pincode',
  RETRY: 'retry',
  SERVICES: 'services',
  WARRANTY: 'warranty',
  WARRANTY_BOX: 'warranty_box',
  WARRANTY_DIALOG: 'warranty_dialog',
  VOLTAGE_DIALOG: 'voltage_dialog',
  BANNER_SERVICE: 'banner_service',
  ADD_SERVICE: 'add_service',
  DIALOG_CLOSE_BUTTON: 'dialog_close_button',
  ADD_TO_CART_BUTTONS_CONTAINER: 'buttons_container',
  ADD_TO_CART_ACTIONS_CONTAINER: 'actions_container',
  ADD_TO_CART_BUTTON: 'add_to_cart_button',
  BUY_BUTTON: 'buy_button',
  INPUT_STEPPER: 'input_stepper',
  ICON: 'icon',
  AVAILABILITY_CONTAINER: 'availability_container',
  BUY_BOX_HEADER: 'buy_box_header',
  BUY_BOX_HEADER_FLAGS: 'buy_box_header_flags',
  BUY_BOX_SELECTOR: 'buy_box_selector',
  BUY_BOX_SELLER_OFFER: 'buy_box_seller_offer',
  PRODUCT_RATING: 'product_rating',
  BREADCRUMB: 'breadcrumb',
  PRODUCT_VARIANT_SELECTOR: 'product_variant_selector',
  COLOR_ATTRIBUTES: 'color_attributes',
  CHIPS_ATTRIBUTES: 'chips_attributes',
  THUMBS_ATTRIBUTES: 'thumbs_attributes',
  PRODUCT_INFORMATION: 'product_information',
  PRODUCT_DESCRIPTION: 'product_description',
  PRODUCT_CHARACTERISTICS: 'product_characteristics',
  PRODUCT_FRACTIONED: 'product_fractioned',
  SEE_MORE: 'see_more',
  SEE_MORE_SELLER_PRODUCTS: 'see_more_seller_products',
  ADD_SERVICES_TO_PRODUCT: 'add_services_to_product',
  ADD_SERVICES_DIALOG: 'add_services_dialog',
  CART_SUMMARY_DIALOG: 'cart_summary_dialog',
  ADDED_SERVICES: 'added_services',
  PRODUCT_INFO: 'product_info',
  SERVICE_ITEM: 'service_item',
  PRICE_INFO: 'price_info',
  WARRANTY_SECTION: 'warranty_section',
  SERVICE_ITEMS: 'service_items',
  SEE_MORE_CHARACTERISTICS: 'see_more_characteristics',
  SHOWCASE_SAME_COLLECTION: 'same_collection',
  SHOWCASE_DIALOG: 'showcase_dialog',
  BACK_TO_TOP: 'back_to_top',
  MADEIRA_ORIGINALS: 'madeira_originals',
  SHOWCASE_TOPBLOCK: 'topblock',
  SHOWCASE_TOP_BLOCK_WITHOUT_BUY_TOGETHER: 'topblockwithoutbuytogether',
  SHOWCASE_MID_BLOCK: 'midblock',
  SHOWCASE_BOTTOM_BLOCK: 'bottomblock',
  REVIEW_SUMMARY: 'review_summary',
  RANGE_INPUT: 'range_input',
  PRODUCT_OUT_OF_STOCK: 'product_out_of_stock',
  PRODUCT_UNAVAILABLE: 'product_unavailable',
  SECTION_REVIEW_CAROUSEL: 'section_review_carousel',
  CODE: 'code',
  SHARE: 'share',
  IMPORT: 'import',
  SELLER_CODE: 'seller_code',
  MENU_LIST: 'menu_list',
  CLEAN: 'clean',
  PRODUCT: 'product',
  SELLER_CODE_ADD: 'seller_code_add',
  SELLER_CODE_REMOVE: 'seller_code_remove',
  INSTALL_CODE: 'install_code',
  INSTALL_CODE_ADD: 'install_code_add',
  INSTALL_CODE_REMOVE: 'install_code_remove',
  BUDGET: 'budget',
  PREORDER: 'preorder',
  EMAIL: 'email',
  PJ: 'pj',
  PF: 'pf',
  CAMPAIGN: 'campaign',
  PHONE: 'phone',
  DOCUMENT: 'document',
  NAME: 'name',
  SUBMIT: 'submit',
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
  OFFICIAL_CHANNELS: 'official_channels',
  SERVICE: 'service',
  BENEFITS: 'benefits',
  SERVICE_SCHEDULE: 'service_schedule',
  SERVICE_PRICE: 'service_price',
  WARRANTY_PRICE: 'warranty_price',
  PRICE: 'price',
  REMOVE: 'remove',
  QUANTITY: 'quantity',
  CONFIRM: 'confirm',
  NOT_NOW: 'not_now',
  COPY: 'copy',
  COPY_CODE: 'copy_code',
  DELETE: 'delete',
  COUPON: 'coupon',
  ZIPCODE: 'zipcode',
  ADD_COUPON: 'add_coupon',
  REMOVE_COUPON: 'remove_coupon',
  ADD_ZIPCODE: 'add_zipcode',
  CHANGE_ZIPCODE: 'change_zipcode',
  CONTINUE: 'continue',
  PRODUCTS_QUANTITY: 'products_quantity',
  PRODUCTS_PRICE: 'products_price',
  COUPON_VALUE: 'coupon_value',
  SUBTOTAL_PRICE: 'subtotal_price',
  SERVICES_QUANTITY: 'services_quantity',
  SERVICES_PRICE: 'services_price',
  WARRANTIES_QUANTITY: 'warranties_quantity',
  WARRANTIES_PRICE: 'warranties_price',
  FREIGHT_PRICE: 'freight_price',
  TOTAL_PRICE: 'total_price',
  ZIPCODE_POPUP: 'zipcode_popup',
  PURCHASE_ALL: 'purchase_all',
  PURCHASE_ALL_DIALOG: 'purchase_all_dialog',
  PURCHASE_ALL_DIALOG_CONTENT: 'purchase_all_dialog_content',
  PURCHASE_ALL_DIALOG_CONTENT_SKELETON: 'purchase_all_dialog_content_skeleton',
  PURCHASE_ALL_DIALOG_PRODUCTS: 'purchase_all_dialog_products',
  PURCHASE_ALL_DIALOG_PRODUCT_CARD: 'purchase_all_dialog_product_card',
  PURCHASE_ALL_DIALOG_RESUME: 'purchase_all_dialog_resume',
  FREIGHT_FLAG: 'freight_flag',
  SELLER: 'seller',
  ADDRESS: 'address',
  CHANGE: 'change',
  DEFAULT: 'default',
  NEW: 'new',
  EDIT: 'edit',
  CANCEL: 'cancel',
  BILLING_ADDRESS: 'billing_address',
  NUMBER: 'number',
  CART_ITEM: 'cart_item',
  CASHBACK: 'cashback',
  CREDIT: 'credit',
  DISCOUNT: 'discount',
  NEW_CREDIT_CARD: 'new_credit_card',
  EXISTING_CREDIT_CARD: 'existing_credit_card',
  PIX: 'pix',
  SLIP: 'slip',
  CARNE_DIGITAL: 'carne_digital',
  CARD_SLIP: 'card_slip',
  TWO_CARDS: 'two_cards',
  NUBANK: 'nubank',
  CREDIT_POS: 'credit_pos',
  DEBIT_POS: 'debit_pos',
  TWO_CREDIT_POS: 'two_credit_pos',
  TWO_DEBIT_POS: 'two_debit_pos',
  CREDIT_DEBIT_POS: 'credit_debit_pos',
  PAYMENT_METHOD: 'payment_method',
  CHANGE_ADDRESS: 'change_address',
  CHANGE_PAYMENT: 'change_payment',
  CHANGE_CARD: 'change_card',
  CARD_INFO: 'card_info',
  CARD_NUMBER: 'card_number',
  CARD_HOLDER: 'card_holder',
  CARD_DATE: 'card_date',
  CARD_CVV: 'card_cvv',
  SAVE: 'save',
  INSTALLMENT: 'installment',
  REQUEST: 'request',
  VALUE: 'value',
  REMAINING: 'remaining',
  DOWN_PAYMENT: 'down_payment',
  INTEREST: 'interest',
  SEARCH: 'search',
  POS_TERMINAL: 'pos_terminal',
} as const;
